module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', {
    key: _vm.$route.fullPath
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-22752f42!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = /N1u
// module chunks = 4